/**
 * Product-page Alpine components.
 * Loaded only for Shopify product requests to keep the shared app payload lean.
 */
document.addEventListener('alpine:init', () => {
    Alpine.data('backInStock', (config = {}) => {
        const isTrue = (value) => value === true || value === 'true' || value === 1 || value === '1';
        const configuredProductId = String(config.productId || '');
        return {
            email: '',
            sms: '',
            channel: 'email',
            customerId: config.customerId || null,
            productId: config.productId || null,
            variantId: config.initialVariantId ? String(config.initialVariantId) : '',
            available: isTrue(config.initialAvailable),
            singleVariantSoldOut: isTrue(
                config.initialDiscontinued ?? config.initialSingleVariantSoldOut
            ),
            bisEligible: isTrue(config.initialBisEligible),
            canSignup: config.canSignup !== false,
            sentEmail: false,
            sentText: false,
            marketing: true,
            loadingChannel: '',
            error: '',
            statusMessage: '',
            submitted: new Set(),
            abortController: null,
            requestTimeout: null,

            get shouldShow() {
                return Boolean(this.variantId) && this.bisEligible && this.canSignup;
            },

            get currentSent() {
                return this.channel === 'email' ? this.sentEmail : this.sentText;
            },

            onVariantChange(eventOrDetail = {}) {
              const detail =
                eventOrDetail?.detail ||
                eventOrDetail ||
                {};

              if (
                configuredProductId &&
                String(detail.productId || '') !== configuredProductId
              ) {
                return;
              }

              this.variantId = detail.variantId
                  ? String(detail.variantId)
                  : '';

                this.variantLabel = detail.variantTitle
                  ? String(detail.variantTitle)
                  : '';
                
                this.available = isTrue(detail.available);
                this.singleVariantSoldOut = isTrue(detail.singleVariantSoldOut);

                if (Object.prototype.hasOwnProperty.call(detail, 'bisEligible')) {
                    this.bisEligible = isTrue(detail.bisEligible);
                } else {
                    this.bisEligible = Boolean(this.variantId)
                        && !this.available
                        && !this.singleVariantSoldOut;
                }

                if (Object.prototype.hasOwnProperty.call(detail, 'canSignup')) {
                    this.canSignup = detail.canSignup !== false;
                }

                this.sentEmail = false;
                this.sentText = false;
                this.error = '';
                this.statusMessage = '';
            },

            submitCurrent() {
                return this.channel === 'sms' ? this.signupText() : this.signupEmail();
            },

            signupEmail() {
                const email = this.email.trim();
                if (!this.variantId) return this.showError('Please select a size first.');
                if (!/^\S+@\S+\.\S+$/.test(email)) return this.showError('Please enter a valid email address.');
                return this.submit({ channel: 'email', email, phone: null });
            },

            signupText() {
                if (!this.variantId) return this.showError('Please select a size first.');
                const phone = this.normalisePhone(this.sms);
                if (!phone) return this.showError('Please enter a valid mobile number.');
                return this.submit({ channel: 'sms', email: null, phone });
            },

            normalisePhone(value) {
                const cleaned = String(value || '').replace(/[\s\-()]/g, '');
                if (/^0[0-9]{9,10}$/.test(cleaned)) return '+44' + cleaned.slice(1);
                if (/^(\+44)[0-9]{9,10}$/.test(cleaned)) return cleaned;
                if (/^(\+1|1)[0-9]{10}$/.test(cleaned)) return cleaned.startsWith('+') ? cleaned : '+' + cleaned;
                if (/^\+[1-9][0-9]{7,14}$/.test(cleaned)) return cleaned;
                return '';
            },

            async submit({ channel, email, phone }) {
                if (this.loadingChannel) return;

                const signature = [this.variantId, channel, email || phone, this.marketing].join('|');
                if (this.submitted.has(signature)) {
                    if (channel === 'email') this.sentEmail = true;
                    if (channel === 'sms') this.sentText = true;
                    this.statusMessage = 'You are already signed up for this size.';
                    return;
                }

                this.abortController?.abort();
                window.clearTimeout(this.requestTimeout);

                this.abortController = new AbortController();

                this.requestTimeout = window.setTimeout(
                  () => this.abortController?.abort(),
                  12000
                );
                this.loadingChannel = channel;
                this.error = '';
                this.statusMessage = 'Saving your notification preference…';

                try {
                    const response = await fetch('https://webhooks.mechanic.dev/0c0853eb-caac-439d-8885-b9b4b3016fa1', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            variant_id: this.variantId,
                            product_id: this.productId,
                            channel,
                            email,
                            phone,
                            customer_id: this.customerId,
                            accepts_marketing: this.marketing
                        }),
                        signal: this.abortController.signal
                    });

                    if (!response.ok) throw new Error('We could not save your notification. Please try again.');

                    this.submitted.add(signature);
                    if (channel === 'email') this.sentEmail = true;
                    if (channel === 'sms') this.sentText = true;
                    this.statusMessage = channel === 'email'
                        ? 'Email notification saved.'
                        : 'SMS notification saved.';
                } catch (error) {
                    this.showError(error.name === 'AbortError'
                        ? 'Saving took too long. Please check your connection and try again.'
                        : (error.message || 'We could not save your notification. Please try again.'));
                } finally {
                    window.clearTimeout(this.requestTimeout);
                      this.requestTimeout = null;
                      this.abortController = null;
                      this.loadingChannel = '';
                }
            },

            showError(message) {
              this.error = message;
              this.statusMessage = message;
            },

            destroy() {
              this.abortController?.abort();
              window.clearTimeout(this.requestTimeout);
            }
        };
    });

      Alpine.data('addWithGiftwrapButton', (config = {}) => {
  const isTrue = (value) =>
    value === true ||
    value === 'true' ||
    value === 1 ||
    value === '1';

  return {
      variantId: config.initialVariantId
        ? String(config.initialVariantId)
        : '',

      variantLabel: config.initialVariantLabel
        ? String(config.initialVariantLabel)
        : '',

      available: isTrue(
        config.initialAvailable
      ),
    giftWrapInCart: isTrue(config.giftWrapInCart),

    loading: false,
    msg: '',

    onVariantChange(detail = {}) {
      if (
        config.productId &&
        String(detail.productId || '') !== String(config.productId)
      ) {
        return;
      }

      this.variantId = detail.variantId
        ? String(detail.variantId)
        : '';

      this.available = isTrue(detail.available);
    },

    selectVariant(event) {
      const option = event?.target?.selectedOptions?.[0];

      if (!option) return;

      const detail = {
        productId: config.productId || null,
        productHandle: config.productHandle || '',
        variantId: option.value ? String(option.value) : '',
        variantTitle: option.dataset.title || '',
        price: option.dataset.price || '',
        available: option.dataset.available === 'true',
        preorderAvailable: option.dataset.preorderAvailable === 'true',
        bisEligible: option.dataset.bisEligible === 'true',
        qtyInStock: Number(option.dataset.qty || 0),
        singleVariantSoldOut: option.dataset.singleSoldOut === 'true'
      };

      this.onVariantChange(detail);
      window.dispatchEvent(new CustomEvent('variant-change', { detail }));
    },

    add(onSuccess = null) {
      if (this.loading) return;

      if (!this.variantId) {
        this.setError('Please select a size');
        this.$nextTick(() => this.$refs.variantSelect?.focus({ preventScroll: true }));
        return;
      }

      if (!this.available) {
        this.setError('Sorry, this size is not available');
        return;
      }

      this.loading = true;

      Alpine.store('cart').addVariant(
        this.variantId,

        // Completion callback
        (error) => {
          this.loading = false;

          if (error) {
            this.setError(
              error.message ||
              'This item could not be added to your bag.'
            );

            return;
          }

          if (typeof onSuccess === 'function') {
            onSuccess();
          }
        },

        // Line-item properties
        {
          _wrapped: true
        },

        // Extra cart items
        null,

        // Existing wrapping workflow:
        // If wrapping already exists, show cart.
        // Otherwise, open the wrapping view.
        this.giftWrapInCart ? 'cart' : 'wrap'
      );
    },

    setError(message) {
      this.msg = message;

      window.setTimeout(() => {
        this.msg = '';
      }, 3000);
    }
  };
});


    Alpine.data('productReviews', (config = {}) => ({

        state: 'idle',

        items: [],

        total: Number(config.initialTotal || 0),

        average: Number(config.initialAverage || 0),

        visibleCount: 6,

        error: '',

        abortController: null,

        cacheTtl: 10 * 60 * 1000,



        get loading() {

            return this.state === 'loading';

        },



        get displayAverage() {

            return Number.isFinite(this.average) ? this.average.toFixed(1) : '0.0';

        },



        get visibleItems() {

            return this.items.slice(0, this.visibleCount);

        },



        get canShowMore() {

            return this.visibleCount < this.items.length;

        },



        cacheKey() {

            return `faf-product-reviews-${config.productId}`;

        },



        readCache() {

            try {

                const cached = JSON.parse(window.sessionStorage.getItem(this.cacheKey()) || 'null');

                if (!cached || Date.now() - cached.savedAt > this.cacheTtl) return null;

                return cached;

            } catch (error) {

                return null;

            }

        },



        writeCache() {

            try {

                window.sessionStorage.setItem(this.cacheKey(), JSON.stringify({

                    savedAt: Date.now(),

                    items: this.items,

                    total: this.total,

                    average: this.average

                }));

            } catch (error) {

                // Storage can be unavailable in private browsing and restricted webviews.

            }

        },



        async load(force = false) {

            if (this.loading || (this.state === 'ready' && !force)) return;



            if (!force) {

                const cached = this.readCache();

                if (cached) {

                    this.items = cached.items || [];

                    this.total = Number(cached.total || this.total);

                    this.average = Number(cached.average || this.average);

                    this.state = 'ready';

                    return;

                }

            }



            this.abortController?.abort();

            this.abortController = new AbortController();

            const timeout = window.setTimeout(() => this.abortController?.abort(), 10000);

            this.state = 'loading';

            this.error = '';



            try {

                const response = await fetch(config.endpoint, {

                    headers: { Accept: 'application/json' },

                    signal: this.abortController.signal

                });

                if (!response.ok) throw new Error('Customer reviews could not be loaded.');



                const payload = await response.json();

                const responseData = payload?.response || {};

                const bottomline = responseData.bottomline || {};

                this.items = (responseData.reviews || [])

                    .filter((review) => Number(review.score || 0) > 2)

                    .map((review) => this.mapReview(review));

                this.total = Number(bottomline.total_review || this.total || this.items.length);

                this.average = Number(bottomline.average_score || this.average || 0);

                this.visibleCount = Math.min(6, this.items.length);

                this.state = 'ready';

                this.writeCache();

            } catch (error) {

                if (error.name === 'AbortError') {

                    this.error = 'The review request timed out. Please check your connection and try again.';

                } else {

                    this.error = error.message || 'Customer reviews could not be loaded.';

                }

                this.state = 'error';

            } finally {

                window.clearTimeout(timeout);

            }

        },



        mapReview(review) {

            const options = ['Felt Small', 'Felt Just Right', 'Felt Big'];

            const metaText = review.custom_fields

                ? Object.keys(review.custom_fields).map((key) => {

                    const field = review.custom_fields[key];

                    const value = options[Number(field.value || 0) - 1] || field.value || '';

                    return `${field.title}: ${value}`;

                }).join(' | ')

                : '';

            const contentText = this.plainText(review.content || '');

            const createdAt = review.created_at || '';



            return {

                id: review.id || `${createdAt}-${review.user?.display_name || 'review'}`,

                author: review.user?.display_name || 'Customer',

                score: Number(review.score || 0),

                title: this.plainText(review.title || ''),

                contentText,

                createdAt,

                dateLabel: this.formatDate(createdAt),

                metaText,

                canExpand: contentText.length > 320,

                expanded: false

            };

        },



        plainText(value) {

            const container = document.createElement('div');

            container.innerHTML = String(value || '');

            return (container.textContent || '').trim();

        },



        formatDate(value) {

            if (!value) return '';

            const date = new Date(value);

            if (Number.isNaN(date.getTime())) return '';

            return new Intl.DateTimeFormat(undefined, { month: 'short', year: 'numeric' }).format(date);

        },



        showMore() {

            this.visibleCount = Math.min(this.visibleCount + 6, this.items.length);

        },



        destroy() {

            this.abortController?.abort();

        }

    }));

    Alpine.data('pdpProduct', (config = {}) => {
        const isTrue = (value) => value === true || value === 'true' || value === 1 || value === '1';
        const productId = Number(config.productId || 0);

        return {
            variantId: config.initialVariantId ? String(config.initialVariantId) : '',
            variantLabel: config.initialVariantLabel || '',
            available: isTrue(config.initialAvailable),
            preorderAvailable: isTrue(config.initialPreorderAvailable),
            bisEligible: isTrue(config.initialBisEligible),
            canSignup: config.canSignup !== false,
            qtyInStock: Number(config.initialQty || 0),
            singleVariantSoldOut: isTrue(config.initialSingleVariantSoldOut),
            adding: false,
            added: false,
            error: '',
            statusMessage: '',
            basePrice:
            config.basePrice ||
            config.initialPrice ||
            '',

          baseCompareAtPrice:
            config.baseCompareAtPrice ||
            '',

          baseSavingAmount:
            config.baseSavingAmount ||
            '',

          baseSavingPercentage: Number(
            config.baseSavingPercentage || 0
          ),

          baseOnSale: isTrue(
            config.baseOnSale
          ),

          selectedPrice:
            config.initialPrice ||
            config.basePrice ||
            '',

          selectedCompareAtPrice:
            config.initialCompareAtPrice ||
            config.baseCompareAtPrice ||
            '',

          selectedSavingAmount:
            config.initialSavingAmount ||
            config.baseSavingAmount ||
            '',

          selectedSavingPercentage: Number(
            config.initialSavingPercentage ??
            config.baseSavingPercentage ??
            0
          ),

          selectedOnSale: isTrue(
            config.initialOnSale ??
            config.baseOnSale
          ),

          selectedTitle:
            config.initialTitle || '',
            queryID: new URLSearchParams(window.location.search).get('queryID') || '',
            resetTimer: null,

            get addToBagText() {
                if (this.adding) return config.addingLabel || 'Adding...';
                if (this.added) return config.addedLabel || 'Added';
                return config.addLabel || 'Add to bag';
            },

            get productAtLimit() {
                return Alpine.store('cart')?.isProductAtLimit(productId) || false;
            },

            init() {
                if (!this.variantId) return;

                this.$nextTick(() => {
                    window.dispatchEvent(new CustomEvent('variant-change', {
                      detail: {
                        productId,
                        productHandle: config.productHandle || '',
                        variantId: Number(this.variantId),
                        variantTitle: this.selectedTitle,

                        price: this.selectedPrice,
                        compareAtPrice: this.selectedCompareAtPrice,
                        savingAmount: this.selectedSavingAmount,
                        savingPercentage: this.selectedSavingPercentage,
                        onSale: this.selectedOnSale,

                        available: this.available,
                        preorderAvailable: this.preorderAvailable,
                        bisEligible: this.bisEligible,
                        canSignup: this.canSignup,
                        qtyInStock: this.qtyInStock,
                        singleVariantSoldOut: this.singleVariantSoldOut
                      }
                    }));
                });
            },

            destroy() {
                window.clearTimeout(this.resetTimer);
            },

            syncVariant(detail = {}) {
              if (
                detail.productId &&
                String(detail.productId) !== String(productId)
              ) {
                return;
              }

              const hasSelectedVariant = Boolean(
                detail.variantId
              );

              this.variantId = hasSelectedVariant
                ? String(detail.variantId)
                : '';

              this.available = isTrue(
                detail.available
              );

              this.preorderAvailable = isTrue(
                detail.preorderAvailable
              );

              this.bisEligible = isTrue(
                detail.bisEligible
              );

              this.qtyInStock = Number(
                detail.qtyInStock || 0
              );

              this.singleVariantSoldOut = isTrue(
                detail.singleVariantSoldOut
              );

              this.selectedTitle =
                detail.variantTitle || '';

              if (hasSelectedVariant) {
                this.selectedPrice =
                  detail.price ||
                  this.basePrice;

                this.selectedCompareAtPrice =
                  detail.compareAtPrice ||
                  '';

                this.selectedSavingAmount =
                  detail.savingAmount ||
                  '';

                this.selectedSavingPercentage =
                  Number(
                    detail.savingPercentage || 0
                  );

                this.selectedOnSale = isTrue(
                  detail.onSale
                );
              } else {
                this.selectedPrice =
                  this.basePrice;

                this.selectedCompareAtPrice =
                  this.baseCompareAtPrice;

                this.selectedSavingAmount =
                  this.baseSavingAmount;

                this.selectedSavingPercentage =
                  this.baseSavingPercentage;

                this.selectedOnSale =
                  this.baseOnSale;
              }

              this.error = '';

              this.statusMessage = this.available
                ? `${this.selectedTitle || 'Size'} selected`
                : `${this.selectedTitle || 'Size'} is unavailable`;

              if (window.history?.replaceState) {
                const url = new URL(
                  window.location.href
                );

                if (this.variantId) {
                  url.searchParams.set(
                    'variant',
                    this.variantId
                  );
                } else {
                  url.searchParams.delete(
                    'variant'
                  );
                }

                window.history.replaceState(
                  window.history.state,
                  '',
                  url.toString()
                );
              }
            },

            onVariantChange(eventOrDetail = {}) {
                this.syncVariant(eventOrDetail?.detail || eventOrDetail || {});
            },

            focusVariantSelector() {
                const selector = this.$root.querySelector('[data-variant-selector]');
                if (!selector) return;

                const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
                selector.scrollIntoView({ behavior, block: 'center' });
                selector.querySelector('label[for]')?.focus({ preventScroll: true });
            },

            emitAddState(state, message = '') {
                window.dispatchEvent(new CustomEvent('pdp-add-state', {
                    detail: {
                        productId,
                        state,
                        message,
                        variantId: this.variantId
                    }
                }));
            },

            onAddRequest(eventOrDetail = {}) {
                const detail = eventOrDetail?.detail || eventOrDetail || {};
                if (detail.productId && String(detail.productId) !== String(productId)) return;
                this.add();
            },

            add() {
                if (this.adding) return;

                if (this.productAtLimit) {
                    const limit = Alpine.store('cart')?.productLimitFor(productId) || 1;
                    this.error = limit === 1
                        ? 'You can only add 1 of this item to your bag.'
                        : `You can only add ${limit} of this item to your bag.`;
                    this.statusMessage = this.error;
                    this.emitAddState('error', this.error);
                    return;
                }

                if (!this.variantId) {
                    this.error = 'Please select a size before adding this item.';
                    this.statusMessage = this.error;
                    this.emitAddState('error', this.error);
                    this.focusVariantSelector();
                    return;
                }

                if (!this.available) {
                    this.error = 'This size is currently unavailable.';
                    this.statusMessage = this.error;
                    this.emitAddState('error', this.error);
                    return;
                }

                const selectedVariantId = String(this.variantId);
                const properties = config.outletOnly ? { 'returns period': 30 } : null;

                this.adding = true;
                this.added = false;
                this.error = '';
                this.statusMessage = `Adding ${config.productTitle || 'item'} to ${config.bagLabel || 'bag'}...`;
                this.emitAddState('loading', this.statusMessage);

                Alpine.store('cart').addVariant(
                    selectedVariantId,
                    (failure) => {
                        this.adding = false;

                        if (failure) {
                            this.error = failure.message || String(failure) || 'This item could not be added. Please try again.';
                            this.statusMessage = this.error;
                            this.emitAddState('error', this.error);
                            return;
                        }

                        this.added = true;
                        this.statusMessage = `${config.productTitle || 'Item'} added to ${config.bagLabel || 'bag'}.`;
                        this.emitAddState('added', this.statusMessage);

                        window.clearTimeout(this.resetTimer);
                        this.resetTimer = window.setTimeout(() => {
                            this.added = false;
                            this.emitAddState('idle');
                        }, 1800);

                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push(this.queryID ? {
                            manualQueryID: this.queryID,
                            algoliaObjectID: selectedVariantId,
                            event: 'searchedAddToCart'
                        } : {
                            algoliaObjectID: selectedVariantId,
                            event: 'addToCart'
                        });
                    },
                    properties,
                    null,
                    'cart',
                    { productId }
                );
            }
        };
    });


    Alpine.data('pdpSticky', (config = {}) => {
        const isTrue = (value) => value === true || value === 'true' || value === 1 || value === '1';
        const productId = Number(config.productId || 0);

        return {
            variantId: config.initialVariantId ? String(config.initialVariantId) : '',
            lastValidVariantId: config.initialAvailable && config.initialVariantId ? String(config.initialVariantId) : '',
            available: isTrue(config.initialAvailable),
            basePrice: config.basePrice || config.initialPrice || '',
            selectedPrice: config.initialPrice || config.basePrice || '',
            selectedTitle: config.initialTitle || '',
            viewportVisible: false,
            adding: false,
            added: false,
            error: '',
            observer: null,
            sentinel: null,
            mediaQuery: null,
            mediaHandler: null,
            resizeHandler: null,
            headerOffsetHandler: null,
            resetTimer: null,

            get visible() {
                return this.viewportVisible && (!this.variantId || this.available);
            },

            get buttonText() {
                if (this.adding) return config.addingLabel || 'Adding...';
                if (this.added) return config.addedLabel || 'Added';
                if (!this.variantId) return config.selectLabel || 'Select size';
                if (!this.available) return config.unavailableLabel || 'Unavailable';
                return config.addLabel || 'Add to bag';
            },

            init() {
                this.mediaQuery = window.matchMedia('(min-width: 1024px)');
                this.mediaHandler = () => this.observeSentinel();
                this.resizeHandler = () => this.updateViewportState();
                this.headerOffsetHandler = () => this.observeSentinel();

                if (this.mediaQuery.addEventListener) {
                    this.mediaQuery.addEventListener('change', this.mediaHandler);
                } else {
                    this.mediaQuery.addListener(this.mediaHandler);
                }

                window.addEventListener('resize', this.resizeHandler, { passive: true });
                window.visualViewport?.addEventListener('resize', this.resizeHandler, { passive: true });
                window.addEventListener('faf:header-offset-change', this.headerOffsetHandler);

                this.$nextTick(() => {
                    this.syncOptions();
                    this.observeSentinel();
                });
            },

            destroy() {
                this.observer?.disconnect();
                window.clearTimeout(this.resetTimer);
                window.removeEventListener('resize', this.resizeHandler);
                window.visualViewport?.removeEventListener('resize', this.resizeHandler);
                window.removeEventListener('faf:header-offset-change', this.headerOffsetHandler);

                if (this.mediaQuery?.removeEventListener) {
                    this.mediaQuery.removeEventListener('change', this.mediaHandler);
                } else {
                    this.mediaQuery?.removeListener(this.mediaHandler);
                }
            },

            syncOptions() {
                const select = this.$refs.variantSelect;
                if (!select) return;

                select.querySelectorAll('option[value]').forEach((option) => {
                    if (!option.value) return;

                    const source = document.querySelector(
                        `[data-pdp-variant-id="${option.value}"][data-pdp-product-id="${productId}"]`
                    );

                    option.disabled = !source || source.dataset.purchasable !== 'true';
                });
            },

            selectVariant(value) {
                const nextId = value ? String(value) : '';
                const previousId = this.lastValidVariantId;

                if (!nextId) {
                    this.variantId = '';
                    this.available = false;
                    this.selectedTitle = '';
                    this.selectedPrice = this.basePrice;
                    this.lastValidVariantId = '';
                    this.error = '';

                    window.dispatchEvent(new CustomEvent('variant-change', {
                        detail: {
                            productId,
                            productHandle: config.productHandle || '',
                            variantId: '',
                            variantTitle: '',
                            price: '',
                            available: false,
                            preorderAvailable: false,
                            bisEligible: false,
                            qtyInStock: 0,
                            singleVariantSoldOut: false
                        }
                    }));
                    return;
                }

                const source = document.querySelector(
                    `[data-pdp-variant-id="${nextId}"][data-pdp-product-id="${productId}"]`
                );

                if (!source || source.dataset.purchasable !== 'true') {
                    this.variantId = previousId;
                    this.error = 'This size is currently unavailable.';
                    this.$nextTick(() => {
                        if (this.$refs.variantSelect) this.$refs.variantSelect.value = previousId;
                    });
                    return;
                }

                this.error = '';
                source.click();
            },

            onVariantChange(eventOrDetail = {}) {
                const detail = eventOrDetail?.detail || eventOrDetail || {};
                if (detail.productId && String(detail.productId) !== String(productId)) return;

                this.variantId = detail.variantId ? String(detail.variantId) : '';
                this.available = isTrue(detail.available);
                this.selectedPrice = detail.price || this.basePrice;
                this.selectedTitle = detail.variantTitle || '';
                if (this.available && this.variantId) this.lastValidVariantId = this.variantId;
                this.error = '';
                this.added = false;
            },

            requestAdd() {
                if (this.adding) return;

                if (!this.variantId) {
                    this.error = 'Please select a size before adding this item.';
                    window.scrollToVariantSelector?.();
                    return;
                }

                if (!this.available) {
                    this.error = 'This size is currently unavailable.';
                    return;
                }

                this.error = '';
                window.dispatchEvent(new CustomEvent('pdp-add-request', {
                    detail: { productId, variantId: this.variantId }
                }));
            },

            onAddState(eventOrDetail = {}) {
                const detail = eventOrDetail?.detail || eventOrDetail || {};
                if (detail.productId && String(detail.productId) !== String(productId)) return;

                this.adding = detail.state === 'loading';
                this.added = detail.state === 'added';
                this.error = detail.state === 'error' ? (detail.message || 'This item could not be added.') : '';

                if (this.added) {
                    window.clearTimeout(this.resetTimer);
                    this.resetTimer = window.setTimeout(() => {
                        this.added = false;
                    }, 1800);
                }
            },

            getStickyOffset() {
                if (this.$store?.appView?.isApp) return 0;

                const desktop = this.mediaQuery?.matches;
                const measurement = window.FAFHeaderOffset?.current;
                const measured = Number(desktop ? measurement?.desktopTop : measurement?.mobileTop);

                if (Number.isFinite(measured) && measured >= 0) return measured;

                const rootStyles = window.getComputedStyle(document.documentElement);
                const offsetProperty = desktop ? '--desktop-menu-offset' : '--mobile-menu-offset';
                const componentOffset = Number.parseFloat(rootStyles.getPropertyValue(offsetProperty));

                if (Number.isFinite(componentOffset) && componentOffset >= 0) {
                    return componentOffset;
                }

                const siteOffset = Number.parseFloat(rootStyles.getPropertyValue('--site-header-offset'));
                if (Number.isFinite(siteOffset) && siteOffset >= 0) return siteOffset;

                return desktop
                    ? Number(config.desktopOffset || 70)
                    : Number(config.mobileOffset || 66);
            },

            observeSentinel() {
                this.observer?.disconnect();
                this.sentinel = document.getElementById(config.sentinelId || '');

                if (!this.sentinel) {
                    this.viewportVisible = false;
                    return;
                }

                const stickyOffset = this.getStickyOffset();

                this.observer = new IntersectionObserver(
                    () => this.updateViewportState(),
                    {
                        root: null,
                        threshold: [0, 1],
                        rootMargin: `-${stickyOffset}px 0px 0px 0px`
                    }
                );

                this.observer.observe(this.sentinel);
                window.requestAnimationFrame(() => this.updateViewportState());
            },

            updateViewportState() {
                if (!this.sentinel) return;

                const rect = this.sentinel.getBoundingClientRect();

                const stickyOffset = this.getStickyOffset();

                // Match desktop on every viewport: keep the sticky CTA hidden until the
                // native Add to Bag button has fully passed behind the sticky/header edge.
                this.viewportVisible = rect.bottom <= stickyOffset;
            }
        };
    });

    Alpine.data('pdpGiftCardPanel', (config = {}) => ({

        variantId: config.initialVariantId ? String(config.initialVariantId) : '',

        available: config.initialAvailable !== false,

        selectedPrice: config.initialPrice || '',

        loading: false,

        name: '',

        email: '',

        message: config.defaultMessage || '',

        sendOn: config.initialSendOn || '',

        errorMessage: '',

        errorTimer: null,

        onVariantChange(eventOrDetail = {}) {

            const detail = eventOrDetail?.detail || eventOrDetail || {};

            if (
                config.productId &&
                String(detail.productId || '') !== String(config.productId)
            ) {
                return;
            }

            this.variantId = detail.variantId ? String(detail.variantId) : '';

            this.available = detail.available !== false;

            if (detail.price) {
                this.selectedPrice = detail.price;
            }

        },

        selectVariant(event) {

            const option = event?.target?.selectedOptions?.[0];

            if (!option) return;

            const detail = {
                productId: config.productId || null,
                productHandle: config.productHandle || '',
                variantId: option.value ? String(option.value) : '',
                variantTitle: option.dataset.title || '',
                price: option.dataset.price || '',
                available: option.dataset.available === 'true',
                qtyInStock: Number(option.dataset.qty || 0),
                singleVariantSoldOut: option.dataset.singleSoldOut === 'true'
            };

            this.onVariantChange(detail);

            if (config.syncProductSelection) {
                window.dispatchEvent(new CustomEvent('variant-change', { detail }));
            }

        },

        add(onSuccess = null) {

            if (this.loading) return;

            if (!this.variantId) {
                this.setError('Please select a gift card amount.');
                this.$nextTick(() => this.$refs.variantSelect?.focus({ preventScroll: true }));
                return;
            }

            if (!this.available) {
                this.setError('This gift card amount is currently unavailable.');
                return;
            }

            if (!this.$refs.form?.reportValidity()) {
                return;
            }

            if (this.message.length > 200) {
                this.setError('Gift messages are limited to 200 characters.');
                this.$nextTick(() => this.$refs.message?.focus({ preventScroll: true }));
                return;
            }

            this.loading = true;
            this.errorMessage = '';

            Alpine.store('cart').addVariant(
                this.variantId,
                (error) => {
                    this.loading = false;

                    if (error) {
                        this.setError(error.message || 'This gift card could not be added to your bag.');
                        return;
                    }

                    this.name = '';
                    this.email = '';
                    this.message = config.defaultMessage || '';
                    this.sendOn = config.initialSendOn || '';

                    if (typeof onSuccess === 'function') {
                        onSuccess();
                    }
                },
                {
                    'Recipient email': this.email,
                    'Recipient name': this.name,
                    Message: this.message,
                    __shopify_send_gift_card_to_recipient: 'true',
                    __shopify_offset: String(new Date().getTimezoneOffset()),
                    __gc_source: 'pdp',
                    __search: config.searchUrl || '',
                    'Send on': this.sendOn
                }
            );

        },

        setError(message) {

            window.clearTimeout(this.errorTimer);
            this.errorMessage = message;
            this.errorTimer = window.setTimeout(() => {
                this.errorMessage = '';
            }, 4000);

        },

        destroy() {

            window.clearTimeout(this.errorTimer);

        }

    }));
   
    Alpine.data('pdpMedia', (config = {}) => {
  let slides = [];
  let ratios = [];

  const mobileDirection =
    config.mobileDirection === 'horizontal'
      ? 'horizontal'
      : 'vertical';

  return {
    activeIndex: 0,
    slideCount: 0,
    observer: null,
    visibilityHandler: null,
    directionHandler: null,
    directionFrame: null,
    mediaQuery: window.matchMedia('(min-width: 1280px)'),
    horizontal: false,
    reducedMotion: window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches,

    init() {
      this.horizontal = this.shouldScrollHorizontally();

      this.directionHandler = () => {
        this.syncDirection();
      };

      if (this.mediaQuery.addEventListener) {
        this.mediaQuery.addEventListener(
          'change',
          this.directionHandler
        );
      } else {
        this.mediaQuery.addListener(this.directionHandler);
      }

      this.$nextTick(() => {
        const slider = this.$refs.slider;
        if (!slider) return;

        /*
         * Only direct children of the scroller can be slides.
         * This prevents nested media markup from creating duplicate indexes.
         */
        slides = Array.from(slider.children).filter((element) =>
          element.matches('[data-pdp-media-slide]')
        );

        this.slideCount = slides.length;
        ratios = slides.map(() => 0);

        if (!this.slideCount) return;

        slides.forEach((slide, index) => {
          slide.dataset.mediaIndex = String(index);
        });

        this.observeSlides();

        this.visibilityHandler = () => {
          if (document.hidden) {
            this.pauseAllVideos();
            return;
          }

          this.setActive(this.activeIndex);
        };

        document.addEventListener(
          'visibilitychange',
          this.visibilityHandler
        );

        this.setActive(0);
      });
    },

    destroy() {
      this.observer?.disconnect();
      this.pauseAllVideos();
      window.cancelAnimationFrame(this.directionFrame);

      if (this.visibilityHandler) {
        document.removeEventListener(
          'visibilitychange',
          this.visibilityHandler
        );
      }

      if (this.directionHandler) {
        if (this.mediaQuery.removeEventListener) {
          this.mediaQuery.removeEventListener(
            'change',
            this.directionHandler
          );
        } else {
          this.mediaQuery.removeListener(this.directionHandler);
        }
      }

      slides = [];
      ratios = [];
    },

    shouldScrollHorizontally() {
      return (
        mobileDirection === 'horizontal' &&
        !this.mediaQuery.matches
      );
    },

    syncDirection() {
      const nextHorizontal = this.shouldScrollHorizontally();

      if (nextHorizontal === this.horizontal) return;

      this.horizontal = nextHorizontal;
      window.cancelAnimationFrame(this.directionFrame);

      /*
       * Wait for the responsive Tailwind classes to change the flex axis,
       * then preserve the currently active slide on the new axis.
       */
      this.directionFrame = window.requestAnimationFrame(() => {
        ratios = slides.map(() => 0);
        this.observeSlides();
        this.positionAt(this.activeIndex, 'auto');
      });
    },

    observeSlides() {
      const slider = this.$refs.slider;

      this.observer?.disconnect();
      this.observer = null;

      if (
        !slider ||
        !slides.length ||
        !('IntersectionObserver' in window)
      ) {
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const index = Number(
              entry.target.dataset.mediaIndex || 0
            );

            ratios[index] = entry.isIntersecting
              ? entry.intersectionRatio
              : 0;
          });

          let bestIndex = this.activeIndex;
          let bestRatio = 0;

          ratios.forEach((ratio, index) => {
            if (ratio > bestRatio) {
              bestRatio = ratio;
              bestIndex = index;
            }
          });

          if (bestRatio < 0.5) return;

          /*
          * Always re-apply the active state. During a snap gesture the
          * current video can briefly fall below the visibility threshold;
          * when it settles on the same slide it must be allowed to resume.
          */
          this.setActive(bestIndex);
        },
        {
          root: slider,
          threshold: [0, 0.25, 0.5, 0.75, 0.9]
        }
      );

      slides.forEach((slide) => {
        this.observer.observe(slide);
      });
    },

    pauseAllVideos() {
      slides.forEach((slide) => {
        slide.querySelectorAll('video').forEach((video) => {
          video.pause();
        });
      });
    },

    setActive(index) {
      if (
        !Number.isInteger(index) ||
        index < 0 ||
        index >= slides.length
      ) {
        return;
      }

      this.activeIndex = index;

      slides.forEach((slide, slideIndex) => {
        slide.querySelectorAll('video').forEach((video) => {
          if (slideIndex !== index || document.hidden) {
            video.pause();
            return;
          }

          /*
           * Set both properties and attributes before play() for Safari and
           * embedded webviews. Autoplay can still be declined by the browser.
           */
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;

          video.setAttribute('muted', '');
          video.setAttribute('playsinline', '');

          if (video.paused) {
            const playRequest = video.play();

            if (playRequest?.catch) {
              playRequest.catch(() => {
                /*
                * Muted inline autoplay can still be blocked by browser or
                * operating-system playback preferences.
                */
              });
            }
          }
        });
      });
    },

    positionAt(index, behavior = null) {
      const slider = this.$refs.slider;
      const target = slides[index];

      if (!slider || !target) return;

      const scrollBehavior = behavior || (
        this.reducedMotion ? 'auto' : 'smooth'
      );

      /*
       * Scroll only the media container. scrollIntoView() can also move the
       * document because the gallery is inside a sticky PDP layout.
       */
      slider.scrollTo({
        left: this.horizontal ? target.offsetLeft : 0,
        top: this.horizontal ? 0 : target.offsetTop,
        behavior: scrollBehavior
      });
    },

    scrollTo(index) {
      this.positionAt(index);
    }
  };
});

    Alpine.data('pdpPanel', (eventName, panelId) => ({
        open: false,
        eventName,
        panelId,
        trigger: null,
        previousBodyOverflow: '',
        lockMode: null,
        scrollLockKey: `pdp-panel:${panelId}`,
        eventHandler: null,

        init() {
            this.eventHandler = (event) => {
                this.openPanel(event?.detail?.trigger || document.activeElement);
            };

            window.addEventListener(this.eventName, this.eventHandler);
        },

        destroy() {
            window.removeEventListener(this.eventName, this.eventHandler);

            if (this.open) this.unlockPage();
        },

        openPanel(trigger) {
            this.trigger = trigger instanceof HTMLElement
                ? trigger
                : document.activeElement;

            this.open = true;
            this.lockPage();

            this.$nextTick(() => {
                this.$refs.closeButton?.focus({ preventScroll: true });
            });
        },

        closePanel() {
            if (!this.open) return;

            this.open = false;
            this.unlockPage();

            this.$nextTick(() => {
                this.trigger?.focus?.({ preventScroll: true });
            });
        },

        lockPage() {
            /*
             * Desktop intentionally leaves the document and PDP media layout 
             * untouched. The modal backdrop prevents wheel/touch interaction,
             * while focus remains trapped inside the drawer. Avoiding any body,
             * html, sticky, height or media-scroll mutations prevents the PDP
             * gallery from being re-laid out when the drawer opens.
             */
            if (window.matchMedia('(min-width: 1280px)').matches) {
                this.lockMode = 'desktop-passive';
                return;
            }

            if (window.FAFScrollLock) {
                this.lockMode = 'global';
                window.FAFScrollLock.lock(this.scrollLockKey);
                return;
            }

            this.lockMode = 'fallback';
            this.previousBodyOverflow = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
        },

        unlockPage() {
            if (this.lockMode === 'desktop-passive') {
                this.lockMode = null;
                return;
            }

            if (this.lockMode === 'global' && window.FAFScrollLock) {
                window.FAFScrollLock.unlock(this.scrollLockKey);
                this.lockMode = null;
                return;
            }

            if (this.lockMode === 'fallback') {
                document.body.style.overflow = this.previousBodyOverflow;
            }

            this.lockMode = null;
        },

        trapFocus(event) {
            if (!this.open || event.key !== 'Tab') return;

            const focusable = Array.from(
                this.$refs.panel?.querySelectorAll(
                    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
                ) || []
            ).filter((element) => (
                !element.hasAttribute('hidden') &&
                element.offsetParent !== null
            ));

            if (!focusable.length) return;

            const first = focusable[0];
            const last = focusable[focusable.length - 1];

            if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus();
            }
        }
    }));
});